import { AlertTriangle, CheckCircle2, Droplets, OctagonX } from "lucide-react";
import { formatGal, formatToEighths, productColor, productName, scanActive } from "@/lib/tank";
import { waterLimit } from "@/lib/safety";
import { useT } from "@/lib/i18n";

export function DropWarning({ sf, testid, mismatchText }) {
  const t = useT();
  if (sf.level === "none") return null;
  const pct = sf.pct.toFixed(1);
  const W = {
    ok: [CheckCircle2, "safe", t("OK to drop"), ""],
    over90: [AlertTriangle, "danger", t("STOP - OVER 90%"), t("This drop puts the tank at {p}%. Max is 90%. Drop no more than {g} gal.", { p: pct, g: formatGal(sf.room90) })],
    over95: [OctagonX, "danger", t("DO NOT DROP - PAST 95% SHUTOFF"), sf.over95 > 0
      ? t("This goes {x} gal past the 95% shutoff. Overfill valve may close mid-drop.", { x: formatGal(sf.over95) })
      : t("This drop reaches the 95% shutoff. Overfill valve may close mid-drop.")],
    overflow: [OctagonX, "danger", t("SPILL RISK - TANK WILL OVERFLOW BY {x} GAL", { x: formatGal(sf.overflow) }), t("Drop no more than {g} gal.", { g: formatGal(sf.room90) })],
    mismatch: [OctagonX, "danger", t("WRONG PRODUCT"), mismatchText],
  }[sf.level];
  const [Icon, tone, head, text] = W;
  return (
    <div className={`drop-warn drop-warn-${tone}`} data-testid={testid} data-level={sf.level} role={tone === "danger" ? "alert" : undefined}>
      <Icon size={22} /><div><b className="drop-warn-head">{head}</b>{sf.level !== "ok" && <p className="drop-warn-text">{text}</p>}</div>
    </div>
  );
}

// Shown under a STOP pill when the drop is also the wrong product.
export function WrongProduct({ text, testid }) {
  const t = useT();
  if (!text) return null;
  return (
    <div className="drop-warn drop-warn-danger" data-testid={testid} data-level="mismatch" role="alert">
      <OctagonX size={22} /><div><b className="drop-warn-head">{t("WRONG PRODUCT")}</b><p className="drop-warn-text">{text}</p></div>
    </div>
  );
}

export function WaterWarning({ s, testid = "water-warning" }) {
  const t = useT();
  if (!scanActive(s) || !(s.scan.water > 0)) return null;
  const high = s.scan.water >= waterLimit();
  return (
    <div className={`drop-warn drop-warn-${high ? "danger" : "caution"}`} data-testid={testid} data-level={high ? "high" : "some"} role="alert">
      <Droplets size={22} />
      <b className="drop-warn-head">{high ? t("HIGH WATER - CALL DISPATCH BEFORE DROPPING") : t("WATER IN TANK: {x}. Check before you drop.", { x: formatToEighths(s.scan.water) })}</b>
    </div>
  );
}

export const ProductTag = ({ id, testid }) => {
  const t = useT();
  return <span className="product-full" data-testid={testid}><span className="grade-dot grade-dot-lg" style={{ background: productColor(id) }} />{t(productName(id))}</span>;
};
